export default __webpack_public_path__ + "static/media/bigimagebanner_beauty.b77ede7a.png";